module.exports = __webpack_public_path__ + "media/images/icons/profile-black-f83c531c9e2fd6377c27d2bd66e00ba9.svg";